type MultiTitleItem = {
  name: string;
  icon: string;
  path: string;
};

interface LeftRailListItemType {
  name: string;
  multiTitle?: MultiTitleItem[];
  icon: string;
  path: string;
  isMultiTab?: boolean;
}
export const leftRailListItem: LeftRailListItemType[] = [
  {
    name: 'Dashboard',
    icon: '/images/dashboard.png',
    path: '/dashboard',
  },
  {
    name: 'Academics',
    multiTitle: [
      { name: 'Schedules', icon: '/images/schedule.png', path: '/academic_schedule' },
      { name: 'Results', icon: '/images/report.png', path: '/results' },
      { name: 'Attendance', icon: '/images/attendance.png', path: '/attendance' },
    ],
    icon: '/images/academic.png',
    path: '/academic_schedule /results /attendence',
    isMultiTab: true,
  },
  {
    name: 'Communication',
    multiTitle: [
      { name: 'Notices', icon: '/images/notice.png', path: '/notice' },
      { name: 'Announcements', icon: '/images/announcement.png', path: '/announcements' },
      { name: 'Circulars', icon: '/images/circular.png', path: '/circular' },
      {
        name: 'Diaries & Homeworks',
        icon: '/images/diary.png',
        path: '/diaries_homework',
      },
      { name: 'Notes', icon: '/images/notes.png', path: '/notes' },
    ],
    icon: '/images/communication.png',
    path: '/notice /announcements /circular /diaries_homework /notes',
    isMultiTab: true,
  },
  {
    name: 'Memories',
    multiTitle: [
      {
        name: 'Events',
        icon: '/images/event.png',
        path: '/events',
      },
      { name: 'Trips', icon: '/images/trip.png', path: '/trips' },
      { name: 'Workshops', icon: '/images/workshop.png', path: '/workshops' },
    ],
    icon: '/images/happening.png',
    path: '/events /trips /workshops',
    isMultiTab: true,
  },
  {
    name: 'Payments',
    multiTitle: [
      {
        name: 'Tuition Fees',
        icon: '/images/tuitionFees.png',
        path: '/tuitionFees',
      },
    ],
    icon: '/images/payment.png',
    path: '/tuitionFees ',
    isMultiTab: true,
  },
];

export const adminRailList: LeftRailListItemType[] = [
  {
    name: 'Administration',
    multiTitle: [
      {
        name: 'Manage Employee',
        icon: '/images/manageEmployee.png',
        path: '/manage-employee',
      },
      { name: 'Manage Students', icon: '/images/manageStudent.png', path: '/manage-student' },
      { name: 'Access Control', icon: '/images/accessManagement.png', path: '/access-control' },
    ],
    icon: '/images/admin.png',
    path: '/manage-employee /manage-student',
    isMultiTab: true,
  },
];
